import { useNavigate } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { useAuth } from "../context/authContext"
import { UserRole } from "../model/userRole"

interface PrivateRouteProps {
    element: JSX.Element
    allowedRoles?: UserRole[]
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, allowedRoles }) => {
    const auth = useAuth()
    // const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null)
    const [isLoadingRoles, setIsLoadingRoles] = useState<boolean>(true)
    const navigate = useNavigate()

    useEffect(() => {
        const check = async () => {
            setIsLoadingRoles(true)
            if (!auth.user) {
                return
            }

            if (allowedRoles) {
                const authorized = await auth.hasAnyRole(...allowedRoles)
                // setIsAuthorized(authorized)
                if (!authorized) {
                    navigate("/")
                }
            }
            // } else {
            //     setIsAuthorized(true)
            // }
            setIsLoadingRoles(false)
        }

        check();
    }, [allowedRoles, auth.user, auth.hasAnyRole, auth.loading])


    if (isLoadingRoles) {
        return <div>Loading...</div>
    }

    return element
}
